<template>
    <div class="container">
        <h1 class="title bluetext is-size-2">¿A quién se lo enviamos?</h1>
        <h2 class="subtitle candidtext is-size-4">Te llegará inmediatamente</h2>
        <img src="https://aiudo.es/wp-content/uploads/2020/06/Google-Reviews-transparent-300x150-1.png" class="rw_referer_funnel">
        <p style="width: 100%; display: block; clear: both;"></p>
        <div style="max-width: 400px;" id="opis">
            <ul class="slider_m">
                <li>
                <strong>Rosa Estevan Hernaiz</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                El equipo se vuelca en ayudarte con cualquier situación que les planteas. Su trato profesional y a la vez emocional hace que sientas que siempre están ahí para atender y solucionar tus dudas. Como siempre os digo: ¡¡¡GRACIAS!!!
                </li> <li>
                <strong>MARIA DE LOS MILAGROS PEDRAZO GONZALEZ</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Atención inmejorable, muy satisfecha con el servicio
                </li> <li>
                <strong>juanvisp</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Contraté los servicios de Aiudo hace escasos meses. No podemos estar más contentos con el servicio y trato por parte de la empresa. Altamente recomendado.
                </li> <li>
                <strong>Abril Peidro Llompart</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                No sabía si contratar este servicio, ya que había tenido una mala experiencia con otra empresa. Al final me animé con Aiudo y de momento está yendo todo genial, esperemos que siga así.
                </li> 
                <li>
                <strong>Carlos Galiana Osca</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Tienen muy buen trato entre los compañeros y clientes. Ademas, encuentran a la persona mas adecuada para cada caso, muy profesionales.
                </li> <li>
                <strong>Diego Lopez</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Destacaría la atención. Decidimos cambiar de cuidador y de horarios y la chica que me atendió, celia, me lo soluciono enseguida.
                </li> <li>
                <strong>David Contador Montiel</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Quería agradeceros el trato que me habéis dado. Han pasado dos meses desde que falleció mi padre y he querido sentarme a escribir unas palabras para vosotros pero me atropellaban los sentimientos. Gracias por vuestra atención desde el primer momento y enhorabuena por vuestro servicio de selección. La cuidadora Glenda ha sido un ángel para la familia. Mis tíos en Málaga también me dicen que están muy contentos con el servicio y me alegro de haberos recomendado.
                </li> <li>
                <strong>marinagg1905</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Muy buena atención además de ofrecer servicio en pequeñas poblaciones Enhorabuena por vuestro trabajo!
                </li> <li>
                <strong>Lore I</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Llevábamos un año con mi padre con Alzheimer y ocupándonos de cuidarle, decidí probar con Aiudo y a día de hoy sigo con su cuidadora. Mi padre está encantado también.
                </li> <li>
                <strong>Ángela DB</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Estoy encantada con el servicio que me ha ofrecido aiudo! Han sido muy amables en todo momento y nos lo han puesto muy fácil siempre. Recomendable!!!!
                </li> <li>
                <strong>Alba Masiá Cantó</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Mi experiencia en Aiudo fue muy positiva. Destacaría el trato recibido, la profesionalidad con la que trabajan y el servicio de calidad que ofrecen.
                </li> <li>
                <strong>Clara Samper</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Muy recomendable.Sin duda repetiría, volveria a confiar en AIUDO para cualquier necesidad en relacion al servicio de cuidadoras internas para el cuidado de personas mayores.
                </li> <li>
                <strong>blanca palomeque</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Estupendos profesionales y sobre todo mucha cercanía. No solo hicieron una selección estupenda , fueron muy rápidos.Me he sentido muy acompañada y apoyada en todo el proceso. Además mantienen el contacto con las familias para comprobar que todo va bien.
                </li> <li>
                <strong>Cristina Berenguer Orquín</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                No había contratado antes cuidador por Internet, fue fácil y el presupuesto muy claro. El servicio fue flexible y gracias a eso pudimos mantener a mi familiar en su casa. 100% recomendable.
                </li> <li>
                <strong>Rosa María Hernaiz Aparicio</strong><br>
                <img src="https://aiudo.es/wp-content/uploads/2018/12/stars_5_yellow.png"><br>
                Empezamos con ellos hace 6 meses y de momento estamos satisfechos. Mi padre y su cuidador conectaron desde el inicio y eso ha hecho las cosas más fáciles. Estamos especialmente contentos del proceso que realizan de búsqueda del cuidador.
                </li>
            </ul>
        </div>
        <div class="field" style="max-width: 400px;">
            <label class="label">Nombre</label>
            <input type="text" class="input" v-model="model.customer.name" name="customer[name]" required>
        </div>
        <div class="field" style="max-width: 400px;">
            <label class="label">Correo electrónico</label>
            <input type="email" class="input" v-model="model.customer.email" name="customer[email]" required>
        </div>
        <div class="field" style="max-width: 400px;">
            <label class="label">Teléfono</label>
            <input type="number" class="input" v-model="model.customer.phone" name="customer[phone]" required>
        </div>
        <div class="field" style="max-width: 400px;">
            <label class="label">Código postal</label>
            <input type="number" class="input" v-model="model.customer.cp" name="customer[cp]" required>
        </div>
        <div class="notification" style="max-width: 400px;">No te preocupes, no compartimos tus datos y los usaremos solamente para elaborar este presupuesto.</div>
        <div class="field" style="max-width: 400px;">
            <label class="checkbox">
                <input type="checkbox" v-model="model.customer.terms" name="customer[terms]" required>
                Acepto los <a href="/condiciones-de-uso" target="_blank">Términos y Condiciones</a> y la <a href="/privacidad" target="_blank">Política de privacidad</a>.
            </label>
        </div>
    </div>
</template>

<script>
import stepMixin from '../mixins/step';

export default {
  name: 'funnel-paso-6',
  mixins: [
    stepMixin
  ],
  mounted () {
    var lineHeight = document.querySelector(".slider_m li").clientHeight; // 0
    var viewHeight = window.innerHeight; // 300
    var slider = document.querySelector(".slider_m");
    var time = (slider.offsetHeight * 2.0 + viewHeight * 2) / 50; // 500px / sec

    slider.style.animationDuration = time + "s";
  }
}
</script>
